import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="results-title" data-id="element-176" data-mp="28f82wp6nw5vc">
      <div className="mx-auto max-w-5xl px-4" data-id="element-177" data-mp="28d54bgrg14f0">
        <p className="text-center text-xs font-extrabold uppercase tracking-[.18em] text-muted" data-id="element-178" data-mp="2d66krt7atc0p">Más resultados reales</p>
        <h2 id="results-title" className="mt-3 text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-179" data-mp="2h6qioyzp4jnw">
          Docentes de Seguridad e Higiene que ya cambiaron su forma de enseñar
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-180" data-mp="2r70wakpn7t3l">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-line bg-mist p-6" data-id="element-181" data-mp="2w4116sarapt4" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-safety" aria-hidden="true" data-id="element-182" data-mp="3il4sbw8pv65v" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-183" data-mp="3doo4l35fittb">“{quote}”</blockquote>
              <div className="mt-auto flex items-center gap-3 border-t border-line pt-4" data-id="element-184" data-mp="38puqb8ibiys3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-navy text-sm font-extrabold text-white" data-id="element-185" data-mp="a5uu4z7y6l3d">
                  {initials}
                </span>
                <span data-id="element-186" data-mp="7ow4sp9hz3s">
                  <b className="block text-sm text-ink" data-id="element-187" data-mp="75e7bzm3apr">{name}</b>
                  <small className="text-xs text-muted" data-id="element-188" data-mp="3sdalvaem9vn6">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}